import React, { useContext } from 'react';
import { ThemeContext } from '../../../Infrastructure/Context/ThemeContext';
import LineIcon from 'react-lineicons';

import './StatCard.scss';

const StatCard = ({ title, stat, subtext, colour, fontSize, icon }) => {
    const context = useContext(ThemeContext);
    return (
        <div className="col-12 col-sm-6 col-lg-4">
            <div className="stat-card">
                <div className="stat-card-header">
                    {icon && (
                        <div className="stat-icon" style={{ backgroundColor: colour ? colour : context.iconColour }}>
                            <LineIcon name={icon} />
                        </div>
                    )}
                    <div className="stat-info">
                        <h4>{title}</h4>
                        <p>{subtext}</p>
                    </div>
                </div>
                <div className="stat-value" style={{ color: colour ? colour : context.iconColour }}>
                    <h3 style={{ fontSize: fontSize }}>{stat !== undefined ? stat : 0}</h3>
                </div>
            </div>
        </div>
    );
};

export default StatCard;